<template>
  <div class="login">
    <div class="login-top">
      <div class="logo">
      梦想新能充电平台
      </div>
    </div>
    <div class="login-center">
      <div class="user-message">
        <div class="user-box">
          <div class="title">密码登录</div>
          <div class="user-content">
            <div class="user-name clearfix">
              <i>
                <img src="../../assets/img/icon_25.png" alt>
              </i>
              <input v-model="username" placeholder="请输入内容">
            </div>
            <div class="user-name clearfix">
              <i>
                <img src="../../assets/img/icon_26.png" alt>
              </i>
              <input v-model="password" type="password" placeholder="请输入内容" @keyup.enter="loginClick">
            </div>
            <div class="user-login">
              <el-button type="primary" @click="loginClick()">登 录</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="interval"></div>
    <div class="login-bottom">
      <div class="bottom-left clearfix">
        <img src="../../assets/img/bottom_logo.png" alt>
      </div>
      <div class="bottom-center clearfix">
        <div class="bot_1">
          <ul>
            <li class="b1">地址：深圳市龙岗区龙城街道龙城工业园留学人员创业园202室</li>
            <li class="b2">电话：18620330331</li>
            <li class="b3">邮箱： 23274501@qq.com</li>
          </ul>
        </div>
      </div>
      <div class="bottom-right clearfix">
        <ul class="image-list">
          <li>
            <img src="../../assets/img/tu.jpg" alt="客户版">
            <span>客户版</span>
          </li>
          <li>
            <img src="../../assets/img/tu_1.jpg" alt="专业版">
            <span>专业版</span>
          </li>
        </ul>
      </div>
      <div style="clear:both"></div>
      <div class="copyright">
        深圳市梦想派科技有限公司 Shenzhen Dreamers Technology Co. Ltd.
        <a
          href="https://beiancx.miit.gov.cn"
          target="_blank"
          class="beian"
        >粤ICP备2022060790号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
// import axios from "axios";
export default {
  data() {
    return {
      input: "",
      username: "",
      password: ""
    };
  },
  mounted() {
         
    this.$nextTick(function() {
      localStorage.clear(); 
      localStorage.setItem('routerName', "homePage");
      // 477682ea27ab34d8d7cb832e0dc22274
    });
    
  },
  methods: {
    loginClick() {
      console.log('click on login')
      localStorage.setItem('routerName', "homePage");
      
      let params = {
        username: this.username,
        password: this.password
      };
      
      this.$api({
        method: "post",
        url: "/api.php/Index/login",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){

            this.$store.state.uid = su.data.data.uid;
            this.$store.state.token = su.data.data.token;
            this.$store.state.role = su.data.role;


            localStorage.setItem("uid",su.data.data.uid); 
            localStorage.setItem("uname",su.data.data.uname);
            localStorage.setItem("token",su.data.data.token);
            localStorage.setItem("nickname",su.data.data.nickname);
            localStorage.setItem("is_customer",su.data.data.is_customer);
            localStorage.setItem("expired_time",su.data.data.expired_time);
            localStorage.setItem("type","旧");
            localStorage.setItem("lastTime",new Date().getTime());
            this.$store.commit("changeEmProvinces","河南");
            this.$store.commit("changeEmCity","");
            this.$store.commit("changeEmStation","");
            

            if(su.data.data.is_customer == 1){
              this.$router.push({ path: "/membershipManagement/gCustomer" });
            } else if(su.data.data.is_customer == 0) {
              this.$router.push({ path: "/homePage" });
            }
            
          } else if(su.data.code == 2){
            this.$message.error(su.data.message);
          } else if(su.data.code == 3){
            this.$message.warning(su.data.message);
          } else if(su.data.code == 4){
            this.$message.error(su.data.message);
          } else if(su.data.code == 5){
            this.$message.error(su.data.message);
          } else if(su.data.code == 6){
            this.$message.warning(su.data.message);
          } else if(su.data.code == 900){

          } else if(su.data.code == 7){
            this.$router.push({ path: "/personalCenter" });
            localStorage.setItem("newid",su.data.uid); 
            localStorage.setItem("type","新");
            localStorage.setItem("nickname",su.data.data.nickname);
            localStorage.setItem("is_customer",su.data.data.is_customer);
            localStorage.setItem("expired_time",su.data.data.expired_time);
            // this.$message.warning(su.data.message);
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
          this.$message.error(err.data.message);
        });
    }
  }
};
</script>

<style lang='scss' scoped>
.login {
  .login-top {
    width: 100%;
    height: 100px;
    background-color: #fff;
    display: flex;
    align-items: center;
    .logo {
      // float: left;
      // width: 290px;
      // height: 53px;
      // margin-left: 46px;
      
      font-size: 30px;
      color: #409eff;
      height: 53px;
      margin-left: 46px;

    }
  }
  .login-center {
    width: 100%;
    height: 600px;
    background: url(../../assets/img/banner.jpg);
    // background-size: 100% auto;
    position: relative;
    .user-message {
      width: 25%;
      position: absolute;
      right: 15%;
      top: 26%;
      background: #fff;
      border-radius: 10px;
      .user-box {
        width: 85%;
        margin: 30px auto;
        .title {
          font-size: 24px;
          color: #0071bd;
          padding-bottom: 20px;
          text-align: left;
        }
        .user-content {
          .user-name {
            margin-bottom: 20px;
            border: 1px solid #e1e1e1;
            i {
              width: 22px;
              height: 22px;
              overflow: hidden;
              margin-top: 16px;
              // margin-left: 16px;
              left: 46px;
              position: absolute;
              z-index: 999;
            }
            input {
              width: calc(100% - 56px);
              float: right;
              height: 50px;
              border:none;
              font-family: "微软雅黑";
              font-size: 14px;
              background-color: #fff;
              outline:none;
              border-radius: 4px;
            }
            input::-webkit-input-placeholder{background-color:#fff;}
            input::-moz-placeholder{background-color:#fff;}
            input:-ms-placeholder{background-color:#fff;}
            input:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {
              // -webkit-text-fill-color: #ededed !important;
              -webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;
              background-color:#fff;
              background-image: none;
              transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
            }
          }
          .user-login {
            .el-button {
              width: 100%;
              height: 50px;
            }
          }
        }
      }
    }
  }
  .interval {
    width: 100%;
    height: 40px;
    background-color: #fff;
  }
  .login-bottom {
    width: 100%;
    height: 260px;
    background-color: #fff;
    .bottom-left {
      width: 28%;
      float: left;
    }
    .bottom-center {
      width: 40%;
      float: left;
      .bot_1 {
        margin-top: 20px; /* 让内容整体往下偏移 20px，可按需调整 */
        margin-left: -50px;
        ul {
          list-style: none;
          li {
            height: 40px;
            text-align: left;
            line-height: 40px;
            font-size: 14px;
            color: #555;
            padding-left: 43px;
          }
          li.b1 {
            background: url(../../assets/img/log_icon.png) no-repeat 0px 7px;
          }
          li.b2 {
            background: url(../../assets/img/log_icon_01.png) no-repeat 0px 7px;
          }
          li.b3 {
            background: url(../../assets/img/log_icon_02.png) no-repeat 0px 7px;
          }
        }
      }
    }
    .bottom-right {
      width: 27%;
      float: right;
      .image-list {
        list-style: none;
        display: flex;
        justify-content: center; /* 让元素居中显示 */
        gap: 33px; /* 设置元素之间的间距，可按需调整 */
        align-items: center;
        padding: 0;
        margin-left: -20px;
        float: left;
        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          img {
            width: 100%;
            max-width: 150px; /* 适当减小图片最大宽度 */
            height: auto;
          }
          span {
            font-size: 12px; /* 适当减小字体大小 */
            color: #555;
            margin-top: 5px; /* 减小文字与图片的间距 */
            display: block;
          }
        }
      }
    }
    .copyright {
      height: 60px;
      line-height: 60px;
      text-align: center;
      border-top: 1px solid #e8e8e8;
      margin-top: 20px;
      font-size: 14px;
      a {
        color: #555;
        text-decoration: none;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/login/login.vue